import request from '../utils/csrf-superagent'; // enhanced superagent to handle jwt-csrf tokens
import config from '../config';
import actions from '../actions/actions';
import vatInformationActions from '../actions/vatInformation';
import companyLocationActions from '../actions/companyLocation';
import reviewPageActions from '../actions/reviewPage';
import helpActions from '../actions/help';

const INVALID_VAT_FORMAT = 'INVALID FORMAT';
const INVALID_OR_EXPIRED_VAT = 'FAILED ADDITIONAL VALIDATION';

function sendIneligibleEmail(store) {
    const state = store.getState();
    const {vatInformation, userInfoDetails} = state;

    const data = (userInfoDetails.userInfoMetadata.ipm.companyRegistration) ? {
        firstName: userInfoDetails.userInfoMetadata.user.firstName,
        lastName: userInfoDetails.userInfoMetadata.user.lastName,
        emailAddress: userInfoDetails.userInfoMetadata.user.emailAddress,
        companyName: userInfoDetails.userInfoMetadata.user.companyName,
        companyLocation: userInfoDetails.userInfoMetadata.companyCountryCode,
        vatStatus: 'No',
        propertyCount: userInfoDetails.userInfoMetadata.ipm.propertyCount,
        message: 'INVALID_VAT_NUMBER'
    } : {
        firstName: vatInformation.vatMetadata.userInformation.user.firstName,
        lastName: vatInformation.vatMetadata.userInformation.user.lastName,
        emailAddress: vatInformation.vatMetadata.userInformation.user.emailAddress,
        companyName: vatInformation.vatMetadata.userInformation.user.companyName,
        companyLocation: vatInformation.vatMetadata.companyCountryInfo.countryName,
        vatStatus: 'Yes',
        propertyCount: vatInformation.vatMetadata.userInformation.ipm.propertyCount,
        message: 'INVALID_VAT_NUMBER'
    };
    const helpFormData = {
        data,
        type: 'INELIGIBLE'
    };
    store.dispatch(helpActions.submitHelpForm(helpFormData));
}

function dispatchVatError(store, message) {
    const errorMessages = {
        [INVALID_VAT_FORMAT]: 'ipmob.vat_page.error.invalid_vat_number_format',
        [INVALID_OR_EXPIRED_VAT]: 'ipmob.vat_page.error.invalid_or_expired_vat'
    };
    const errorKey = errorMessages[message.toUpperCase()] || 'ipmob.vat_page.error.invalid_or_expired_vat';
    store.dispatch(vatInformationActions.alertError(errorKey));
}

function handleIPMFlow(store, error, response, rvsEnabled) {
    const companyRegistration = store.getState().userInfoDetails.userInfoMetadata.ipm.companyRegistration;
    const successStatusCode = rvsEnabled ? 200 : 204;

    if (error) {
        store.dispatch(actions.enableLoadOverLay(false));
        store.dispatch(vatInformationActions.alertError('ipmob.vat_page.error.internal_service_error'));
    } else if (response.statusCode === successStatusCode) {
        if (rvsEnabled) {
            try {
                const parsedResponse = JSON.parse(response.text);
                if (parsedResponse.success === false) {
                    sendIneligibleEmail(store);
                    store.dispatch(actions.enableLoadOverLay(false));
                    dispatchVatError(store, parsedResponse.message);
                    return;
                }
            } catch (e) {
                store.dispatch(actions.enableLoadOverLay(false));
                store.dispatch(vatInformationActions.alertError('ipmob.error.process.request'));
                return;
            }
        }
        store.dispatch(actions.changeAppState('LISTING_MODEL'));
    } else if (companyRegistration) {
        const parsedResponse = JSON.parse(response.text);
        if (parsedResponse.code >= 400) {
            sendIneligibleEmail(store);
        }
        store.dispatch(actions.enableLoadOverLay(false));
        store.dispatch(actions.changeAppState('LISTING_MODEL'));
    } else {
        const parsedResponse = JSON.parse(response.text);
        if (parsedResponse.code === 715) {
            sendIneligibleEmail(store);
            store.dispatch(actions.enableLoadOverLay(false));
            dispatchVatError(store, parsedResponse.message);
        } else {
            store.dispatch(actions.enableLoadOverLay(false));
            store.dispatch(vatInformationActions.alertError('ipmob.error.process.request'));
        }
    }
}

function handlePPMFlow(store, error, response, rvsEnabled) {
    const successStatusCode = rvsEnabled ? 200 : 204;

    if (error) {
        store.dispatch(actions.enableLoadOverLay(false));
        store.dispatch(reviewPageActions.alertErrorForModal('ipmob.internal.server.error'));
    } else if (response.statusCode === successStatusCode) {
        if (rvsEnabled) {
            try {
                const parsedResponse = JSON.parse(response.text);
                if (parsedResponse.success === false) {
                    store.dispatch(actions.enableLoadOverLay(false));
                    store.dispatch(reviewPageActions.alertErrorForModal('ipmob.error.process.request'));
                    return;
                }
            } catch (e) {
                store.dispatch(actions.enableLoadOverLay(false));
                store.dispatch(reviewPageActions.alertErrorForModal('ipmob.error.process.request'));
                return;
            }
        }
        store.dispatch(reviewPageActions.updateServiceSuccess());
    } else {
        store.dispatch(actions.enableLoadOverLay(false));
        store.dispatch(reviewPageActions.alertErrorForModal('ipmob.error.process.request'));
    }
}

function handleBillingSetupFlow(store, error, response, isFromCompanyLocation, rvsEnabled) {
    const successStatusCode = rvsEnabled ? 200 : 204;

    if (error) {
        store.dispatch(actions.enableLoadOverLay(false));
        if (isFromCompanyLocation) {
            store.dispatch(companyLocationActions.alertError('ipmob.internal.server.error'));
        } else {
            store.dispatch(vatInformationActions.alertError('ipmob.vat_page.error.internal_service_error'));
        }
    } else if (response.statusCode === successStatusCode) {
        if (rvsEnabled) {
            try {
                const parsedResponse = JSON.parse(response.text);
                if (parsedResponse.success === false) {
                    store.dispatch(actions.enableLoadOverLay(false));
                    if (isFromCompanyLocation) {
                        store.dispatch(companyLocationActions.alertError('ipmob.company_location.error.invalid_registration'));
                    } else {
                        dispatchVatError(store, parsedResponse.message);
                    }
                    return;
                }
            } catch (e) {
                store.dispatch(actions.enableLoadOverLay(false));
                if (isFromCompanyLocation) {
                    store.dispatch(companyLocationActions.alertError('ipmob.error.process.request'));
                } else {
                    store.dispatch(vatInformationActions.alertError('ipmob.error.process.request'));
                }
                return;
            }
        }
        store.dispatch(actions.changeAppState('BILLING_INFORMATION'));
    } else {
        const parsedResponse = JSON.parse(response.text);
        if (parsedResponse.code === 715) {
            store.dispatch(actions.enableLoadOverLay(false));
            if (isFromCompanyLocation) {
                store.dispatch(companyLocationActions.alertError('ipmob.company_location.error.invalid_registration'));
            } else {
                dispatchVatError(store, parsedResponse.message);
            }
        } else {
            store.dispatch(actions.enableLoadOverLay(false));
            if (isFromCompanyLocation) {
                store.dispatch(companyLocationActions.alertError('ipmob.error.process.request'));
            } else {
                store.dispatch(vatInformationActions.alertError('ipmob.error.process.request'));
            }
        }
    }
}

function updateVatDetails(store, action) {
    const vatDetails = action.payload.vatDetails;
    const isBillingSetupFlow = action.payload.isBillingSetupFlow;
    const isFromCompanyLocation = !!action.payload.isFromCompanyLocation;
    const state = store.getState();
    const rvsEnabled = state.app.dyff && state.app.dyff.SHARED_RVS_VAT_VALIDATION_ENABLED;

    request.post(`/${config.url_prefix}/api/updateVatDetails?isBillingSetupFlow=${isBillingSetupFlow}`)
        .send({
            data: vatDetails
        })
        .set('x-homeaway-site', state.system.siteName)
        .end((error, response) => {
            const {app} = state;
            if (isBillingSetupFlow) {
                handleBillingSetupFlow(store, error, response, isFromCompanyLocation, rvsEnabled);
            } else if (app.userType === 'IPM') {
                handleIPMFlow(store, error, response, rvsEnabled);
            } else {
                handlePPMFlow(store, error, response, rvsEnabled);
            }
        });
}

export default updateVatDetails;
